import {
  FormControl,
  FormControlProps,
  InputLabel,
  InputLabelProps,
  MenuItem,
  MenuItemProps,
  Select,
  SelectProps,
  styled,
  Typography,
} from '@/primitives';

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.common.black,
  fontWeight: 'bold',
  ['&[data-shrink="true"]']: {
    color: 'grey',
    paddingLeft: '1rem',
  },
  ['&[data-shrink="false"]']: {
    paddingLeft: '1rem',
  },
}));

interface Props extends FormControlProps {
  label?: string;
  labelProps?: InputLabelProps;
  options: (MenuItemProps & { label: string })[];
  selectProps?: SelectProps;
  selectedValue?: MenuItemProps['value'];
}

export default function LabelSelectInput(props: Props) {
  const {
    label,
    labelProps,
    options = [],
    selectProps,
    selectedValue,
    ...rest
  } = props;

  return (
    <FormControl variant="standard" {...rest}>
      {label ? (
        <StyledLabel color="info" shrink={!!selectedValue} {...labelProps}>
          {label}
        </StyledLabel>
      ) : null}
      <Select
        color="info"
        disableUnderline
        value={selectedValue}
        {...selectProps}
        sx={{ paddingLeft: '0.5rem', ...selectProps?.sx }}
      >
        {options.map(({ key, ...item }, index) => (
          <MenuItem key={index} {...item}>
            <Typography
              variant="labellarge"
              sx={{
                fontWeight: 'bold',
                whiteSpace: 'wrap',
              }}
            >
              {item.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
